<!-- Shows migrate device options -->
@if (!showImportDevicesScreen && !showTransferDevicesScreen) {
	<div class="slightly-rounded-backdrop">
		<div class="grid-options-container">
			<!-- Import Devices Container -->
			@if (isOracle) {
				<div class="migrate-devices-container-option import-device-container-option">
					<h3 i18n="@@migrateDevicesTab-importDevicesHeader" class="migrate-device-header">Import Devices</h3>
					<hr class="teal-device-divider" />
					<div i18n="@@migrateDevicesTab-importDevicesDesc" class="migrate-device-desc">
						Bulk import devices by entering a list of serial numbers. This feature enables rapid addition of multiple
						devices, reducing manual entry time.
					</div>
					<button
						class="primary-small-button import-devices-continue-button"
						data-automation-id="import-devices-continue-button"
						(click)="onImportDevicesContinueClicked()"
						i18n="@@migrateDevicesTab-continueButton"
					>
						Continue
					</button>
				</div>
			}
			<!-- Transfer Devices Container -->
			<div class="migrate-devices-container-option">
				<h3 i18n="@@migrateDevicesTab-transferDevicesHeader" class="migrate-device-header">Transfer Devices</h3>
				<hr class="teal-device-divider" />
				<div i18n="@@migrateDevicesTab-transferDevicesDesc" class="migrate-device-desc">
					Reassign multiple devices to one company by pasting a list of serial numbers. Quickly update device ownership
					in bulk.
				</div>
				<button
					class="primary-small-button transfer-devices-continue-button"
					data-automation-id="transfer-devices-continue-button"
					(click)="onTransferDevicesContinueClicked()"
					i18n="@@migrateDevicesTab-continueButton"
				>
					Continue
				</button>
			</div>
		</div>
	</div>
}

@if (showImportDevicesScreen && !showTransferDevicesScreen) {
	<div class="slightly-rounded-backdrop padding-15-pixels">
		<app-add-device-main-tab
			[appBreadcrumbLabel]="importDeviceBreadcrumbLabel"
			(goBack)="goBack($event)"
			[isTransferringDevices]="false"
		></app-add-device-main-tab>
	</div>
}

@if (showTransferDevicesScreen && !showImportDevicesScreen) {
	<div class="slightly-rounded-backdrop padding-15-pixels">
		<app-add-device-main-tab
			[appBreadcrumbLabel]="transferDeviceBreadcrumbLabel"
			(goBack)="goBack($event)"
			[isTransferringDevices]="true"
		></app-add-device-main-tab>
	</div>
}
